import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import InlineForm from "../FromGroup/InlineForm";
import Component from "../../../components/AscComponent";
import CommonTable from "../Table/CommonTable";

/**
 * カテゴリ名編集アイテム
 * state.category_nameが必要
 */
export class EditCategoryName extends Component {
    render() {
        return (
            <InlineForm
                key="category_name"
                controlId="category_name"
                type="text"
                label={this.props.langText.Body.VocCategoryName}
                value={this.props.state.category_name}
                onChange={e => this.props.onTextChange_Limit(e, "category_name", this.props.charaLimit.vocCategoryName)}
            />
        );
    }
}

/**
 * カテゴリ名ビューアイテム
 * state.category_nameが必要
 */
export class ViewCategoryName extends Component {
    render() {
        return (
            <InlineForm
                key="category_name"
                controlId="category_name"
                label={this.props.langText.Body.VocCategoryName}
                readOnly
                children={this.props.state.category_name}
            />
        );
    }
}

/**
 * 分析指示内容編集アイテム
 * state.prompt_textが必要
 */
export class EditPromptText extends Component {
    render() {
        return (
            <InlineForm
                key="prompt_text"
                controlId="prompt_text"
                label={
                    <span>
                        {this.props.langText.Body.VocCategoryPromptText}
                        {' '}
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip>
                                    {this.props.langText.Message.VocCategoryPromptHint}
                                </Tooltip>
                            }
                        >
                            <i className="icon-info-circled" style={{ color: '#17a2b8', cursor: 'pointer' }} />
                        </OverlayTrigger>
                    </span>
                }
            >
                <textarea
                    className="form-control"
                    rows={5}
                    value={this.props.state.prompt_text}
                    onChange={e => this.props.onTextChange_Limit(e, "prompt_text", this.props.charaLimit.vocCategoryPromptText)}
                    placeholder={this.props.langText.Message.Placeholder_InputPromptText}
                />
                <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                    {this.props.state.prompt_text.length} / {this.props.charaLimit.vocCategoryPromptText}文字
                </div>
            </InlineForm>
        );
    }
}

/**
 * 分析指示内容ビューアイテム
 * state.prompt_textが必要
 */
export class ViewPromptText extends Component {
    render() {
        return (
            <InlineForm
                key="prompt_text"
                controlId="prompt_text"
                label={this.props.langText.Body.VocCategoryPromptText}
                readOnly
            >
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {this.props.state.prompt_text}
                </div>
            </InlineForm>
        );
    }
}

/**
 * 削除項目ビューアイテム
 * state.selectedDataが必要
 */
export class ViewDeleteVocCategoryList extends Component {
    render(){
        return(
            <CommonTable
                showPagination={true}
                defaultPageSize={10}
                columns={[{
                    Header: this.props.langText.Body.VocCategoryName,
                    accessor: "category_name",
                },
                {
                    Header: this.props.langText.Body.VocCategoryPromptText,
                    accessor: "prompt_text",
                    Cell: ({row}) => {
                        const text = row.original.prompt_text || '';
                        const maxLength = 50;
                        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
                    }
                }]}
                data={this.props.state.selectedData}
            />
        );
    }
}
